<script>
export default {
    name: "ConsultantPaymentHistory",

    data() {

        return {
            paymentDetails: [],
        };
    },

    components: {

        "view-payment-details": () => import('../../view-payments/modals/View.vue'),
    },

    props: {

        showModal: Boolean,
        consultantPayments: Array,
        consultant: Object,
        filter: Object,
    },

    methods: {

        fetchPaymentDetails(payment) {
            this.$root.loading=true;
            let url = `Accounts/GetConsultantPaymentsPaidDetails`;
                url += `?InvoiceRef=${payment.invoiceRef}`;
            return this.$http.get(url).then(response => {
                    this.paymentDetails=response.data;
                    this.$root.loading=false;
                }).catch(() => { this.$root.loading=false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-5/6 w-10/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Consultant Payment History</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full overflow-auto">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-xs">
                        <tr class="flex w-full">
                           <th class="p-tiny flex-1">Date</th>
                           <th class="p-tiny flex-1">Ref</th>
                           <th class="p-tiny w-1/5">Memo</th>
                           <th class="p-tiny flex-1">Mode</th>
                           <th class="p-tiny flex-1">Amt</th>
                           <th class="p-tiny flex-1">Paid</th>
                           <th class="p-tiny flex-1">Balance</th>
                           <th class="p-tiny flex-1">Paid By</th>
                           <th class="p-tiny flex-1">Action</th>
                        </tr>
                    </thead>
                    <tbody class="flex flex-col items-center text-xs overflow-auto bg-gray-100" 
                        style="max-height:65vh;">
                        <tr 
                          class="w-full flex" 
                          v-for="(consultantPayment, idx) in consultantPayments" :key="idx">
                            <td class="p-tiny flex-1">{{ consultantPayment.trxDate | dateFormat }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.invoiceRef || `-` }}</td>
                            <td class="p-tiny w-1/5">{{ consultantPayment.invoiceMemo || `-` }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.mode }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.amount | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.paid | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.balance | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ consultantPayment.paidBy }}</td>
                            <td class="p-tiny flex-1">
                                <button
                                    @click.prevent="fetchPaymentDetails(consultantPayment).then(() => { 
                                        consultantPayment.view=true; 
                                    })"
                                    class="btn-sm btn-primary text-xs rounded-md">
                                        <i class="fa fa-eye"></i> View</button>
                                    <view-payment-details
                                        :payment="consultantPayment"
                                        :paymentDetails="paymentDetails"
                                        :showModal="consultantPayment.view"
                                        :consultant="consultant.names"
                                        @closeModal="consultantPayment.view=false"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>